import { GoodReceived } from "../GoodReceived/GoodReceived.type";
import { ApiCallState, PagedData } from "../Utils";

export type GRVValidation = {
    id: number;
    date: string;
    good_received_id: number;
    status: "Approved" | "Revision" | "Rejected";
    remark: string;
    good_received: GoodReceived;
};

export type GRVValidationStateTypes = {
    fetchAll: ApiCallState<GRVValidation[]>;
    fetchPaged: ApiCallState<PagedData<GRVValidation[]>>;
    fetchOne: ApiCallState<GRVValidation | {}>;
};

export const GRVValidationActionTypes = {
    FETCH_ALL_GRV_VALIDATION: "FETCH_ALL_GRV_VALIDATION",
    FETCH_ALL_GRV_VALIDATION_RESET: "FETCH_ALL_GRV_VALIDATION_RESET",
    FETCH_ALL_GRV_VALIDATION_FAILURE: "FETCH_ALL_GRV_VALIDATION_FAILURE",
    FETCH_ALL_GRV_VALIDATION_SUCCESS: "FETCH_ALL_GRV_VALIDATION_SUCCESS",

    FETCH_ONE_GRV_VALIDATION: "FETCH_ONE_GRV_VALIDATION",
    FETCH_ONE_GRV_VALIDATION_RESET: "FETCH_ONE_GRV_VALIDATION_RESET",
    FETCH_ONE_GRV_VALIDATION_FAILURE: "FETCH_ONE_GRV_VALIDATION_FAILURE",
    FETCH_ONE_GRV_VALIDATION_SUCCESS: "FETCH_ONE_GRV_VALIDATION_SUCCESS",

    FETCH_PAGED_GRV_VALIDATION: "FETCH_PAGED_GRV_VALIDATION",
    FETCH_PAGED_GRV_VALIDATION_RESET: "FETCH_PAGED_GRV_VALIDATION_RESET",
    FETCH_PAGED_GRV_VALIDATION_FAILURE: "FETCH_PAGED_GRV_VALIDATION_FAILURE",
    FETCH_PAGED_GRV_VALIDATION_SUCCESS: "FETCH_PAGED_GRV_VALIDATION_SUCCESS",
};
